@if (listsettings.appliedFilters.length > 0) {
<div class="bg-light d-inline-block filters">
  <div class="px-0 py-2">
    @for (filter of listsettings.appliedFilters; track filter) {
    <div class="card bg-light mx-1 d-inline-block mb-2">
      <div class="card-header py-1 px-2">
        <small>{{ filter.label }}</small>
        <i class="far fa-window-close fa-sm cursor-pointer" (click)="removeFilter(filter)"></i>
      </div>
      <div class="card-body py-2 px-2">
        @for (value of filter.values; track value) {
        <span class="badge badge-pill badge-info mr-1">
          {{ value }}
        </span>
        }
      </div>
    </div>
    }
  </div>
</div>
}
<div class="table-responsive scrollbar" [style.--scrollbar-margin-left]="getScrollbarMarginLeft()">
  <table class="table table-hover table-light table-fixed">
    <thead>
      <tr>
        @for (col of layout; track col; let idx = $index) {
        @if (col.type !='actions-dropdown' && col.type!='actions-inline') {
        <th class="text-left nowrap nav-font14 grey5" [ngStyle]="getStickyStyle(-1, idx, true)">
          @if (col.filterable) {
          <or-list-filter [values]="col.filterValues"
            [ngClass]="{'position-relative': (idx+1) === layout?.length, 'last-column': (idx+1) === layout?.length}"
            (opened)="getFilterValues(col)" (filter)="applyFilter($event, col)"></or-list-filter>
          }&nbsp;
          <div class="d-inline-block" [ngClass]="{'sortable': col.sortable}"
            (click)="col.sortable > 0 && sortList(col)">
            {{ col.label }}
            @if (col.sortable) {
            <i class="fas fa-sm or-secondary"
              [ngClass]="{'fa-sort-down': sortBy == col.id && sortDir == 'DESC', 'fa-sort-up': sortBy == col.id && sortDir == 'ASC', 'fa-sort': sortBy != col.id}"></i>
            }
          </div>
        </th>
        }
        @if (col.type=='actions-dropdown' || col.type=='actions-inline') {
        <th class="text-left nowrap nav-font14 grey5" [ngStyle]="getStickyStyle(-1, idx, true)">
          {{showActionColLabel == true ? col.label : "" }}
          <!-- TO DO: SUPPORT MORE TABLE LEVEL ACTIONS-->
          @if (enableExport) {
          <i class="fas fa-download cursor-pointer or-secondary" (click)="exportTable()"></i>
          }
        </th>
        }
        }
      </tr>
      @if (summary != null) {
      <tr class="table-primary">
        @for (col of layout; track col) {
        <th>
          {{ summary[col.id] }}
        </th>
        }
      </tr>
      }
    </thead>
    <tbody>
      @for (item of displayList; track item; let i = $index) {
      <tr class="grey5 nav-font14" [ngClass]="{'table-info': item?.selected}">
        @for (col of layout; track col; let colIdx = $index) {
        <td [class.selectable]="col.selectable" class="text-left"
          (click)="rowSelected(col, item)"
          [ngClass]="col._cssClass"
          [ngStyle]="getStickyStyle(i, colIdx, false)"
          [class.nowrap]="col.type !== null && col.type !== 'text' && col.type !== 'number' && col.type !== 'bool'">
          @if (col.editOnly || (item.editMode != null && item.editMode[col.id] != null)) {
          @if (col.type == null || col.type == 'text') {
          @if (col.options == null) {
          <input type="text" class="form-control" [(ngModel)]="item.editMode[col.id].value"
            (ngModelChange)="autoSaveChange($event, item, col)">
          } @else {
          <select class="custom-select d-block w-100" [ngModel]="item.editMode[col.id].value"
            (ngModelChange)="autoSaveChange($event, item, col)">
            @for (option of col.options; track option) {
            <option [ngValue]="option"> {{ option }}</option>
            }
          </select>
          }
          }
          @if (col.type == 'number' || col.type == 'percent' || col.type == 'currency' ) {
          <input type="text" class="form-control" [(ngModel)]="item.editMode[col.id].value">
          }
          @if (col.type == 'users') {
          @if (item['_isArray_' + col.id]) {
          <or-type-ahead [labelField]="'name'" [valueField]="'id'" [dataCallback]="getUserList"
            placeholder="Type to search..."
            (valueChange)="item.editMode[col.id].value = ($event.length == 0) ? null : $event[0].id"
            [selectedValues]="item[col.id]"></or-type-ahead>
          }
          }
          @if (col.type == 'date' || col.type == 'countdown') {
          <div class="input-group mb-1">
            <input type="text" autocomplete="off" class="form-control form-control-sm bg-white" readonly
              #dp="bsDatepicker" [bsValue]="item.editMode[col.id].value"
              (bsValueChange)="autoSaveChange($event, item, col)" bsDatepicker
              [bsConfig]="{ dateInputFormat: 'MMM Do, YYYY', isAnimated: true, isOpen:true, showWeekNumbers:false, customTodayClass: 'todays-date',  selectFromOtherMonth: true }">
            <div class="input-group-append">
              <button class="btn btn-light border" type="button" (click)="dp.toggle()"><i
                  class="far fa-calendar-alt"></i></button>
            </div>
          </div>
          }
          <div class="mt-1 float-right">
            @if (col.editable && !(col.editOnly == true)) {
            <button (click)="item.editMode[col.id] = null" type="button" class="btn btn-outline-secondary mx-1 py-2">
              <i class="fa fa-times fa-xs"></i>
            </button>
            }
            @if (col.editable && (col.autoSave == null || col.autoSave == false)) {
            <button (click)="saveChange(item, col)" type="button" class="btn btn-outline-secondary">
              <i class="fa fa-check fa-xs"></i>
            </button>
            }
          </div>
          }
          @if (!(col.editOnly == true) && (item.editMode == null || item.editMode[col.id] == null)) {

            @if (col.editable && col.type != 'status') {
            <span tooltip="Edit" container="body" (click)="enableEdit(item, col)">
              <i class="fas fa-edit cursor-pointer or-secondary"></i>&nbsp;
            </span>
            }
            @if (col.type == 'stage') {
            <or-project-stage [stage]="item['currentStage']" [color]="item['currentStageColor']"
              [percentComplete]="item._computed_percentComplete"></or-project-stage>
            }
            @if (col.type == null || col.type == 'text' || col.type == 'number' || col.type == 'bool') {
              @if (col.selectable && clickroute!='') {
              <a class="nav-accent-blue font-weight-bold nav-link p-0" [routerLink]="[clickroute, item[rowid]]"
                [ngClass]="{'text-truncate': col.width > 0}" [style.width.px]="col.width">
                {{ item[col.id] }}
              </a>
              }

              @if (col.selectable && clickroute=='' && item.fileName != 'Rollback') {
              <a class="nav-accent-blue font-weight-bold nav-link p-0 align-left"
                [ngClass]="{ 'text-truncate': col.width > 0 }" [style.width.px]="col.width">
                @if (showtooltip== true) {
                <span class="font-weight-bold" container="body"
                  [tooltip]="item[col.id]" placement="top"> {{ item['_truncated_' + col.id] || item[col.id] }}
                </span>
                } @else {
                {{ item[col.id] }}
                }
              </a>

              }
              @if (col.selectable && clickroute=='' && item.fileName == 'Rollback') {
              <a class="nav-accent-blue font-weight-bold p-0 noFile" [ngClass]="{'text-truncate': col.width > 0}"
                [style.width.px]="col.width">
                {{ item[col.id] }}
              </a>
              }
              @if (!col.selectable) {
              <div [ngClass]="{'text-truncate': col.width > 0}" [style.width.px]="col.width">
                @if (col.type == 'number') {
                {{col.prefix}}{{ item[col.id] | number }}{{col.suffix}}
                }
                @if (col.type != 'number') {
                @if (showtooltip == true && item['_showTooltip_' + col.id]) {
                <span class="font-weight-bold" container="body"
                  [tooltip]="item[col.id]" placement="top">{{ item[col.id] }}
                </span>
                } @else {
                {{ item[col.id] }}
                }
                }
                @if (col.badge && (col.badge.invert ? !item[col.badge.field] : item[col.badge.field])) {
                  <span class="badge badge-pill ml-2 {{ col.badge.cssClass || 'badge-secondary' }}">{{ col.badge.label }}</span>
                }
              </div>
              }
            }
            @if (col.type == 'percent') {
            <div [ngClass]="{'text-truncate': col.width > 0}" [style.width.px]="col.width">
              {{ item[col.id] | number }} %
            </div>
            }
            @if (col.type == 'currency') {
            <div [ngClass]="{'text-truncate': col.width > 0}" [style.width.px]="col.width">
              {{ item[col.id] | currency }}
            </div>
            }
            @if (col.type == 'cleanID') {
            {{ item[col._computedKey] }}
            }
            @if (col.type == 'icon') {
            <i class="cursor-default" [ngClass]="item[col.id]"></i>
            }
            @if (col.type == 'status') {
            <div class="or-dropdown-status id-list-status">
              @if (col.editable) {
              <or-dropdown-status
                [status]="item[col.id]"
                [projectId]="item.id"
                [values]="col.statusValues"
                [autosave]="col.autosave ?? true"
                [showLaunchPopup]="col.showLaunchPopup ?? true"
                [showIcons]="col.showIcons ?? true"
                [disabled]="col.disableEdit ? col.disableEdit(item) : false"
                (changed)="onStatusChanged($event, item, col)">
              </or-dropdown-status>
              }
            </div>
            @if (!col.editable ) {
            <span [ngClass]="{'text-truncate': col.width > 0}" [style.width.px]="col.width">{{item[col.id]}}</span>
            }
            }
            @if (col.type == 'link') {
            <a target="_blank" href="http://{{item[col.id]}}">{{item[col.id]}}</a>
            }
            @if (col.type == 'email') {
            <or-email-address [emailaddress]="item[col.id]"></or-email-address>
            }
            @if (col.type == 'img') {
            <or-profile-image [url]="item[col.id]" [name]="item.name" size="small" showInitials="true"></or-profile-image>
            }
            @if (col.type == 'users') {
            <div class="d-inline-flex ml-2 position-relative users">
              <or-profile-image [names]="item[col.id]" size="small" showInitials="true"></or-profile-image>
            </div>
            }
            @if (col.type == 'address') {
            <or-address [address]="item[col.id]"></or-address>
            }
            @if (col.type == 'countdown') {
            <span>{{ item[col._computedCountdownKey] }} </span>
            <div><small>{{ item[col.id] | date: 'MMM d, y' }}</small></div>
            }
            @if (col.type == 'date') {
            {{ item[col.id] | date: 'MMM d, y' }}
            }
            @if (col.type == 'datetime') {
            {{ item[col.id] | date: 'MMM d, y HH:mm' }}
            }
            @if (col.type == 'datetimeToolTip') {
            <span class="font-weight-bold" container="body" [tooltip]="tooltipMessage + ' ' + item[col._computedDateKey]" placement="top">
              {{  item[col.id] }}
            </span>
            }
            @if (col.type == 'tag') {
            @if (item[col.id].mode == null || item[col.id].mode == 'dot') {
            <span [ngClass]="'badge-' + item[col.id].type || 'info'" class="badge badge-pill p-2">
              {{ item[col.id].label }}
            </span>
            }
            @if (item[col.id].mode == 'badge') {
            <span>
              <div [ngClass]="'bg-' + item[col.id].type || 'info'" class="rounded-circle dot float-left mt-1"></div>
              <small>&nbsp;{{ item[col.id].label }}</small>
            </span>
            }
            }
            @if (col.type == 'countries' && item[col.id]?.length > 0) {
            <div class="d-flex justify-content-start">
              <span class="countries-pill">
                @if (item.isFraudDetectionGeoCountryEnabled) {
                <i class="fal fa-lock countries-icon" aria-label="Geo-restricted" container="body"
                  tooltip="All markets in this project are geo-restricted"></i>
                }
                <span class="countries-text">{{ item[col._computedVisibleLabelKey] }}</span>
                @if (item[col._computedHiddenCountKey] > 0) {
                <span class="countries-overflow" container="body" [tooltip]="item[col._computedHiddenLabelKey]">
                  +{{ item[col._computedHiddenCountKey] }}
                </span>
                }
              </span>
            </div>
            }
            @if (col.type == 'tags') {
            <div class="scrollbar overflow-y" [class.row]="!(col.id == 'countriesSupportedAsTags' && item[col.id] && item[col.id][0]?.tag === 'All')" [class.tags]="!(col.id == 'countriesSupportedAsTags' && item[col.id] && item[col.id][0]?.tag === 'All')">
              @for (tag of item[col.id]; track tag) {
              <div class="badge badge-pill badge-light text-uppercase m-1 or-primary-bg text-white" [class.quota-pill-light]="tag.tag !== 'All' && col.id == 'countriesSupportedAsTags'">
                @if (tag.tag === 'All' && col.id == 'countriesSupportedAsTags') {
                  <i class="fas fa-globe" aria-hidden="true"></i>All Countries
                } @else {
                  {{ tag.tag }}
                }
              </div>
              }
            </div>
            }
            @if (col.type == 'toggle') {
            <or-toggle-button [id]="item.Id" [isChecked]="item[col.id]" [isDisabled]="true" msgON="YES" msgOFF="NO">
            </or-toggle-button>
            }
            @if (col.type == 'actions-dropdown' && actions && isInternal) {
              <div class="btn-group btn-group-sm id-list-actions" dropdown container="body">
                <button id="button-basic" dropdownToggle type="button" class="btn btn-outline-secondary"
                  controls="dropdown-basic">
                  <span><i class="fa fa-ellipsis-h"></i></span>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" [class]="colIdx <4 ? ' dropdown-menu-left' :'dropdown-menu-right'"role="menu"
                  aria-labelledby="button-basic">
                  @for (action of item._filteredActions || actions; track action) {
                  <li role="menuitem">
                    <or-action-button [label]="action.label" [description]="action.description" [icon]="action.icon"
                      (selected)="actionSelected(item, action.type)"></or-action-button>
                  </li>
                  }
                </ul>
              </div>
            }
            @if (col.type == 'alert') {
              @for (alert of item[col.id+'_icons']; track alert) {
              <span container="body" tooltip="{{ alert.message }}" class="mr-1">
                <i [ngClass]="alert.icon"></i>
              </span>
              }
            }
            @if (col.type == 'health') {
              @for (alert of item[col.id+'_icons']; track alert) {
              <span html="true" tooltip="{{ alert.tooltip }}" container="body"
                class="health badge badge-pill {{ alert.status }} mr-1 p-2">
                {{ alert.message }}
              </span>
              }
            }
            @if (col.type == 'actions-inline' && actions) {
              <div class="btn-group btn-group-sm">
                @for (action of actions; track action) {
                @if (!col.actionTypes || col.actionTypes.includes(action.type)) {
                  @if (action.enabledField && !item[action.enabledField]) {
                    <!-- disabled: wrap in a span so the tooltip still shows on hover -->
                    <span class="d-inline-block" [tooltip]="action.disabledTooltip || action.label" container="body">
                      <button type="button" class="btn btn-outline-secondary list-action-btn" [attr.aria-label]="action.label" disabled>
                        <i [ngClass]="(action.iconClass || 'fa fa-' + action.icon) + ' or-secondary'" aria-hidden="true"></i>
                      </button>
                    </span>
                  } @else {
                    <button type="button" (click)="actionSelected(item, action.type)" class="btn btn-outline-secondary list-action-btn"
                      [attr.aria-label]="action.label"
                      [tooltip]="action.noTooltip ? '' : action.label" container="body">
                      <i [ngClass]="(action.iconClass || 'fa fa-' + action.icon) + ' or-secondary'" aria-hidden="true"></i>
                    </button>
                  }
                }
                }
              </div>
            }
            @if (col.type == 'actions-checkbox' && actions) {
              <div class="btn-group btn-group-sm w-100 d-flex justify-content-center">
                @for (action of actions; track action) {
                <input class="btn btn-outline-secondary" tooltip="{{ action.label }}" container="body"
                  (change)="actionSelected(item, action.type, $event)" type="checkbox">
                }
              </div>
            }
            @if (col.type == 'client-status') {
              <div class="btn-group btn-group-sm w-100 d-flex" dropdown #ddClientStatus="bs-dropdown" container="body">
                <div class="d-block text-center" (click)="ddClientStatus.toggle(true);">
                  @if (item[col.id] === null) {
                    <i class="fa fa-ellipsis-h cursor-pointer"></i>
                  }
                  @else {
                    <span class="client-status-item cursor-pointer m-1 {{ item[col.id] }}"></span>
                  }
                </div>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-client-status" [class]="colIdx <4 ? ' dropdown-menu-left' :'dropdown-menu-right'"role="menu"
                  aria-labelledby="button-basic">
                  <li role="menuitem" (click)="clientStatusSelected(item, col, 'good', ddClientStatus)">
                    <span class="client-status-item cursor-pointer good m-1"></span>
                  </li>
                  <li role="menuitem" (click)="clientStatusSelected(item, col, 'warning', ddClientStatus)">
                    <span class="client-status-item cursor-pointer warning m-1"></span>
                  </li>
                  <li role="menuitem" (click)="clientStatusSelected(item, col, 'bad', ddClientStatus)">
                    <span class="client-status-item cursor-pointer bad m-1"></span>
                  </li>
                </ul>
              </div>
            }
            @if (col.type == 'notes' && item[col.id]) {
               <div class="notes-container d-flex">
                  <div class="notes-content text-truncate" [innerHTML]="item[col._computedNoteKey]"></div>
                  <span  class="nav-accent-blue font-weight-bold cursor-pointer p-0" (click)="actionSelected(item, 'notes', $event)">
                    View notes <i class="fa fa-chevron-right nav-font10 grey4 ml-1"></i>
                  </span>
              </div>
            }
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
  @if (itemsToLoad < itemCount) { <button class="nav-btn-primary shadow-none w-100 mb-3 mt-3" (click)="loadMore()">Load
    More</button>
    }

</div>
